var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlagGreece(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3223_18058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.86956H23.5866C23.2857 7.75328 22.8284 6.70136 22.2387 5.73911H12V8.86956Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53058 21.3913H19.4702C20.5654 20.5191 21.5046 19.4596 22.2391 18.2609H1.76172C2.4963 19.4596 3.43548 20.5191 4.53058 21.3913Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17433 2.90338C3.23092 3.71577 2.41534 4.67244 1.76172 5.73913H4.17433V2.90338Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 10.7777 12 9.75472 12 8.86954H7.30434V12H4.17389V8.86954H0.413391C0.144375 9.86769 0 10.9169 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1304H23.5867C23.8556 14.1323 24 13.0831 24 12H12Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 0C10.334 0 8.74703 0.339984 7.30469 0.953812V5.73914H12.0003C12.0003 4.64639 12.0003 3.717 12.0003 2.60869H19.4702C17.4203 0.976125 14.8245 0 12.0003 0Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3223_18058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagGreece);
export default __webpack_public_path__ + "static/media/icon_flag_greece.0be7cdc69887b81c7b826fc4860e623a.svg";
export { ForwardRef as ReactComponent };